<template>
  <v-footer color="py-0" padless>
    <v-row justify="center" no-gutters>
      <v-col class="white py-2 pe-2" cols="12">
        <div class="logo-wrapper">
          <div class="logo"><img :src="require('@/assets/images/logos/dvg-labhoh-logos.svg')" /></div>
        </div>
      </v-col>
      <v-col class="primary py-0 pe-2 text-right white--text" cols="12" style="font-size: 12px">
        {{ appVersion ? appVersion : 'dev' }}
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  props: ['appVersion'],
};
</script>

<style lang="scss">
.logo-wrapper {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  .logo {
    display: inline-block;
    margin: 5px 20px 0 20px;
    height: 80px;
    img {
      max-width: 100%;
      width: 400px;
      height: 80px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .logo-wrapper {
    .logo {
      display: inline-block;
      margin: 5px 20px 0 20px;
      height: 60px;
      img {
        max-width: 100%;
        width: 180px;
        height: 60px;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
